var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1642_3310)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2939 19.1451L19.3313 13.7203C19.753 13.266 19.9404 12.642 19.8385 12.0306L19.3706 9.2234C19.135 7.80966 18.304 6.56501 17.0886 5.8054L15.4377 4.77358C15.1506 4.59415 14.9138 4.3448 14.7494 4.04887L13.3441 1.51936C12.86 0.648005 11.8082 0.266128 10.8778 0.623958L7.5136 1.9179C6.52979 2.29629 5.69073 2.97591 5.11627 3.85969L0.235467 11.3686C-0.208962 12.0524 -0.193759 12.9375 0.27389 13.6055L1.91041 15.9434C2.61235 16.9462 3.65773 17.6566 4.84847 17.9401L12.3651 19.7298C13.0664 19.8968 13.8034 19.6734 14.2939 19.1451ZM12.2114 3.23716C12.3424 2.84421 12.1301 2.41947 11.7371 2.28848C11.3441 2.1575 10.9194 2.36987 10.7884 2.76282L10.2884 4.26282C10.1574 4.65578 10.3698 5.08052 10.7628 5.21151C11.1557 5.34249 11.5805 5.13012 11.7114 4.73716L12.2114 3.23716ZM9.71144 3.73716C9.84243 3.34421 9.63006 2.91947 9.2371 2.78848C8.84415 2.6575 8.4194 2.86987 8.28842 3.26282L7.28842 6.26282C7.15743 6.65578 7.3698 7.08052 7.76276 7.21151C8.15572 7.34249 8.58046 7.13012 8.71144 6.73716L9.71144 3.73716ZM6.23973 7.3767C6.17163 6.96812 5.78521 6.6921 5.37663 6.7602C4.96806 6.82829 4.69204 7.21472 4.76014 7.62329L5.17425 10.108L2.12783 11.8488C1.76819 12.0543 1.64324 12.5125 1.84875 12.8721C2.05426 13.2317 2.5124 13.3567 2.87204 13.1512L5.99607 11.366L11.3017 14.461L11.7557 18.093C11.8071 18.504 12.1819 18.7956 12.593 18.7442C13.004 18.6928 13.2955 18.318 13.2441 17.907L12.7869 14.2493L17.5549 9.0045C17.8335 8.69801 17.8109 8.22367 17.5044 7.94504C17.1979 7.66641 16.7236 7.689 16.445 7.99549L11.8534 13.0462L6.68186 10.0295L6.23973 7.3767Z",
    fill: "#653024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1642_3310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreu);
export default __webpack_public_path__ + "static/media/breu.41aee9e2c50bfa1faf85fde90251553b.svg";
export { ForwardRef as ReactComponent };